module.exports = __webpack_public_path__ + "static/media/035-anesthesia.8f9bfb50.svg";